var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock_open_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lock_open_svg__ds",
    x1: 42,
    y1: 137,
    x2: 207.29,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lock_open_svg__dt",
    x1: 229.17,
    y1: 281.73,
    x2: 314.51,
    y2: 281.73,
    xlinkHref: "#lock_open_svg__ds"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m130.26,57s-10.96,0-10.96,0c-20.29.02-39.47,7.09-53.98,19.93-7.2,6.37-12.87,13.82-16.87,22.14-4.2,8.74-6.33,18.04-6.35,27.62l-.1,57.37c0,3.29,1.27,6.38,3.59,8.7,2.32,2.33,5.41,3.61,8.71,3.62,6.77,0,12.29-5.51,12.3-12.28l.1-57.37c.01-5.89,1.33-11.62,3.93-17.03,3.87-8.07,10.36-15,18.76-20.02,8.83-5.28,19.18-8.07,29.93-8.08,0,0,10.92,0,10.94,0,13.99,0,27.16,5.46,37.07,15.36,9.91,9.91,15.36,23.08,15.37,37.1l-.03,70.63c0,3.29,1.28,6.38,3.6,8.7,2.32,2.32,5.41,3.6,8.7,3.61h0c6.78,0,12.3-5.52,12.3-12.3l.03-70.66c0-20.58-8.01-39.92-22.57-54.47-14.54-14.55-33.88-22.57-54.46-22.57Z",
    style: {
      fill: "url(#lock_open_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.83,239.06c-11.4,0-22.11,4.44-30.15,12.5-8.07,8.06-12.51,18.77-12.5,30.17,0,11.4,4.44,22.12,12.5,30.17,8.05,8.07,18.76,12.51,30.17,12.51h.01c11.4,0,22.11-4.44,30.15-12.5,8.07-8.05,12.51-18.77,12.51-30.17,0-11.4-4.44-22.12-12.5-30.17-8.05-8.06-18.76-12.51-30.18-12.51Zm12.79,55.44c-3.42,3.42-7.96,5.3-12.77,5.3-4.82,0-9.35-1.88-12.77-5.29-3.42-3.42-5.3-7.96-5.3-12.78,0-4.82,1.89-9.35,5.29-12.77,3.42-3.42,7.96-5.3,12.77-5.3,4.82,0,9.35,1.88,12.77,5.29,3.42,3.43,5.3,7.96,5.3,12.78,0,4.82-1.89,9.36-5.29,12.77Z",
    style: {
      fill: "url(#lock_open_svg__dt)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.07,205.82v-.92c-.08-1.81-.55-3.63-1.36-5.26-1.06-2.13-2.69-3.94-4.72-5.23-1.98-1.25-4.27-1.96-6.62-2.03-.04,0-.74,0-.74,0-2.86-.01-19.68-.02-40-.02h-122.85c-10.93,0-20.9,0-28.19,0h-8.7c-1.05,0-3.14.01-3.14.01,0,0-.66,0-.69.01-1.66.06-3.27.44-4.8,1.13-2.12.95-3.94,2.45-5.29,4.35-1.43,2.01-2.25,4.38-2.38,6.84,0,.04-.02.76-.02.76,0,.76,0,3.23,0,7.02,0,3.77,0,8.83,0,14.72l.03,92.59c0,13.86,5.41,26.89,15.22,36.69,9.8,9.81,22.83,15.21,36.7,15.21h125.67c13.86,0,26.89-5.4,36.68-15.2,9.81-9.8,15.22-22.83,15.22-36.69l.03-92.49c0-6.39,0-11.8,0-15.65v-5.83Zm-204.93,11.14c7.32,0,17.48,0,28.63,0h122.85c10.92,0,28.86,0,28.86,0,0,3.01,0,6.5,0,10.35l-.03,92.48c0,7.28-2.85,14.14-8.01,19.3-5.17,5.16-12.03,8-19.31,8.01h-125.65c-7.28,0-14.14-2.85-19.3-8-5.16-5.17-8.01-12.03-8.01-19.31l-.03-74.22s0-25.63,0-28.61Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.f62ee8c2085950429923e59df8b2f952.svg";
export { ForwardRef as ReactComponent };